import { StandardEvents } from '@shopify/events';

const pending = new Set();
const set = (node, name, value) => { if (node.getAttribute(name) !== value) node.setAttribute(name, value); };
function syncNativeCheckout() {
  document.querySelectorAll('[data-joa-native-product]').forEach(details => {
    if (details.querySelector('.mw-option [name^="mw_opts["]')) return;
    const shell = details.querySelector('.joa-express-shell');
    const form = shell?.querySelector('form');
    const productForm = details.querySelector('product-form-component form');
    if (!shell || !form || !productForm) return;
    const id = productForm.querySelector('[name="id"]')?.value;
    const purchaseButton = productForm.querySelector('button[name="add"]');
    const deposit = details.querySelector('#purchase-option-deposit-input')?.checked === true;
    const busy = pending.has(details) || !id || purchaseButton?.disabled === true;
    const ready = !busy && !deposit;
    set(shell, 'data-joa-native-checkout', ready ? 'ready' : 'hidden');
    set(form, 'data-joa-express-state', ready ? 'ready' : 'preparing');
    set(form, 'data-joa-wallet-state', 'native');
    set(shell, 'data-joa-deposit-selected', String(deposit));
    form.inert = !ready;
    set(shell, 'data-joa-express-state', ready ? 'ready' : 'preparing');
    const gate = form.querySelector('[data-joa-express-gate]');
    if (gate) { gate.disabled = !ready; set(gate, 'aria-disabled', String(!ready)); }
    const payment = form.querySelector('.shopify-payment-button');
    if (payment) payment.inert = !ready;
    const idInput = form.querySelector('[name="id"]');
    if (idInput && idInput.value !== id) { idInput.value = id || ''; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
    const quantity = form.querySelector('[name="quantity"]');
    if (quantity) quantity.value = productForm.querySelector('[name="quantity"]')?.value || '1';
    const widget = form.querySelector('.accelerated-checkout-block');
    if (widget) widget.hidden = !ready;
    const status = form.querySelector('[data-joa-express-status]');
    if (status) status.hidden = true;
  });
}
let queued = false;
function schedule() {
  if (queued) return;
  queued = true;
  requestAnimationFrame(() => { queued = false; syncNativeCheckout(); });
}
document.addEventListener(StandardEvents.productSelect, event => {
  const details = event.target.closest('[data-joa-native-product]');
  if (!details || !event.promise) return;
  pending.add(details); syncNativeCheckout();
  event.promise.finally(() => { pending.delete(details); schedule(); }).catch(() => {});
});
document.addEventListener('change', schedule);
document.addEventListener('joa:apo-statechange', schedule);
new MutationObserver(schedule).observe(document.querySelector('#MainContent') || document.body, { childList: true, subtree: true });
schedule();
